import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VTooltip,{attrs:{"bottom":"","color":_vm.tipColor,"disabled":!_vm.enabled},scopedSlots:_vm._u([{key:"activator",fn:function({on, attr}){return [_c(VIcon,_vm._g(_vm._b({class:_vm.btnClass,attrs:{"disabled":!_vm.enabled,"color":_vm.btnColor},on:{"click":function($event){return _vm.$emit('click')}}},'v-icon',attr,false),on),[_vm._v("\n      "+_vm._s(_vm.icon)+"\n    ")])]}}])},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.tooltip)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }